import React from "react";
import { Link } from "react-router-dom";

const AboutOne = () => {
  return (
    <div className="about-area-1 position-relative space-top">
      <div className="about1-shape-img1">
        <img
          className="about1-shape-img-1"
          src="assets/img/normal/about.jpg"
          alt="img"
        />
      </div>
      <div className="about1-shape-img2">
        <img
          className="about1-shape-img-2"
          src="assets/img/normal/about_shape1-2.png"
          alt="img"
        />
      </div>
      <div className="container">
        <div className="row gx-60 align-items-center">
          <div className="col-xl-6">
            <div className="about-content-wrap">
              <div className="title-area me-xl-5 mb-20">
                <span className="sub-title">
                  <img src="assets/img/icon/title_left.svg" alt="shape" />
                  About Us
                </span>

              </div>
              <div className="achive-about">
                <div className="achive-about_content">
                  <div className="achive-about_icon">
                    <i className="fas fa-check" />
                  </div>
                  <div className="media-body">
                    <h4 className="box-title">A Modern Approach to Procurement, Services, and Construction</h4>
                    <p className="achive-about_text">
                      We are a newly established procurement, service, and construction company, designed
                      to uphold the highest standards of professionalism and operational excellence. By
                      leveraging a strong blend of expertise, innovation, and strategic insight, we are uniquely
                      positioned to deliver outstanding solutions to clients across Europe and the Middle East.
                    </p>
                  </div>
                </div>
              </div>
              <div className="achive-about">
                <div className="achive-about_content">
                  <div className="achive-about_icon">
                    <i className="fas fa-check" />
                  </div>
                  <div className="media-body">
                    <h4 className="box-title">
                      Tailored Solutions for Sustainable Growth and Long-Term Impact
                    </h4>
                    <p className="achive-about_text">
                      Our comprehensive suite of services is tailored to meet the complex demands
                      of each project, ensuring optimal outcomes through a consistent focus on
                      quality, efficiency, and precision. Committed to driving sustainable growth
                      and building long-term partnerships, we aim to empower our clients and deliver
                      transformative results across diverse sectors and industries.
                    </p>
                  </div>
                </div>
              </div>
              <div className="btn-wrap mt-20">
                <Link to="/about" className="global-btn mt-xl-0 mt-20">
                  Read More <i className="fas fa-arrow-right ms-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutOne;
